import MobileDivider from "./MobileDivider";

export default MobileDivider;
export { MobileDivider };
